import { useQuery } from '@tanstack/react-query';
import {
  SITE_CONTENT_DEFAULTS,
  type PublicSiteContent,
  type SiteContentKey,
  type SiteContentEntry,
} from '@pms/shared';
import { fetchSiteContent } from '../services/api/siteContent.api';

/**
 * Live homepage marketing stats (super-admin managed). Shared query key so the
 * single GET is deduped across EditorialHero + BrandDifference. Long staleTime —
 * marketing copy changes rarely. On error/loading `data` is undefined and every
 * consumer falls back to defaults, so the homepage never blocks or breaks.
 */
export function useSiteContent() {
  return useQuery<PublicSiteContent>({
    queryKey: ['site-content'],
    queryFn: fetchSiteContent,
    staleTime: 5 * 60 * 1000,
  });
}

/** Resolve one stat: stored override if present, else the canonical default. */
export function resolveStat(
  map: PublicSiteContent | undefined,
  key: SiteContentKey,
): SiteContentEntry {
  return map?.[key] ?? SITE_CONTENT_DEFAULTS[key];
}
